import { useEffect } from 'react';
import { App } from 'antd';
import { useDispatch, useSelector } from 'react-redux';
import { setMessage } from '../redux/slice';

const AppMessage = () => {
  const dispatch = useDispatch();
  const message = useSelector((state) => state.common.message);
  const { message: antMessage } = App.useApp();

  useEffect(() => {
    if (message) {
      antMessage.success({
        content: message,
        onClose: () => dispatch(setMessage(null)),
      });
    }
  }, [message, dispatch, antMessage]);

  return null;
};

export default AppMessage;
